(ns app.front.view.group.admin.remove-user
  (:require [app.front.state-machine :as sm]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [goog.functions]
            [re-chain.core :as rc]
            [re-frame.core-instrumented :as rf]))



(defn reset-db [db]
  (update db ::document
          assoc
          :db/id nil
          :user/email nil
          :user/first-name nil
          :user/last-name nil
          :parent-group-id nil
          :dispatch-after-submit nil
          ::show-errors? false
          ::state nil))


(defn reset-db-wo-user [db]
  (update db ::document
          assoc
          :db/id nil
          :parent-group-id nil
          :dispatch-after-submit nil
          ::show-errors? false
          ::state nil))


(def state-machine
  {nil          {::init ::ready}
   ::ready      {::try-submit ::submitting}
   ::submitting {::submit-errors  ::server-errors
                 ::submit-success ::done}})


;; -- Subscriptions -----------------------------------------------------------

(rf/reg-sub
  ::document
  (fn [db [_ path f]]
    (let [doc     (::document db)
          sub-doc (if path (get-in doc path) doc)]
      (if f (f sub-doc) sub-doc))))



(rf/reg-sub
  ::state
  :<- [::document]
  (fn [document _] (get document ::state)))


(rf/reg-sub
  ::modal-open?
  :<- [::state]
  (fn [state _] (not (contains? #{nil ::done} state))))

;; -- Events ------------------------------------------------------------------

(def update-next-state (sm/make-update-next-state state-machine
                                                  [::document ::state]))

(def debug (rf/after (fn [db event]
                       (.log js/console "=======")
                       (.log js/console "state: " (str (-> db ::document ::state)))
                       (.log js/console "event: " (str event)))))

(def interceptors [(rf/inject-cofx :tr) (when ^boolean js/goog.DEBUG debug)])


(rc/reg-chain-named*
  interceptors
  ::try-submit
  (fn [{:keys [db]} [event _]]
    {:db           (update-next-state db event)
     :comm/command {:command        :group/remove-user
                    :data           {:user/id         (-> db ::document :db/id)
                                     :parent-group-id (-> db ::document :parent-group-id)}
                    :on-bad-request [::submit-failure.bad-request]
                    :on-forbidden   [::submit-failure.forbidden]}})
  ::submit-success
  (fn [{:keys [tr db]} _]
    {:db         (reset-db-wo-user db)
     :dispatch-n [(-> db ::document :dispatch-after-submit)
                  [:notifications/add
                   :toast
                   :success
                   (tr [:user-management/removed])
                   (tr [:user-management/removed])]]}))


(rc/reg-chain* ::submit-failure.bad-request
  interceptors
  (fn [{:keys [db tr]} [event status body]]
    (js/console.error "::submit-failure" status body)
    {:db       (-> db
                   (assoc-in [::document ::server-errors] (:errors body))
                   (update-next-state event))
     :dispatch [:notifications/add
                :inline
                :error
                (tr [:error/error])
                (tr [(or (some-> body :error)
                         :error/bad-request)])]}))


(rc/reg-chain* ::submit-failure.forbidden
  interceptors
  (fn [{:keys [db tr]} [event status body]]
    (js/console.error "::submit-failure" status body)
    {:db       (update-next-state db event)
     :dispatch [:notifications/add
                :inline
                :error
                (tr [:error/error])
                (tr [:error/forbidden])]}))


(rc/reg-chain* ::open
  interceptors
  (fn [{:keys [db]} [_ group-id user dispatch-after-submit]]
    {:db (-> db
             reset-db
             (assoc-in [::document :parent-group-id] group-id)
             (assoc-in [::document :dispatch-after-submit] dispatch-after-submit)
             (update ::document #(merge % user)))})
  (fn [{:keys [db]} _]
    {:db (-> db (update-next-state ::init))}))


(rf/reg-event-fx
  ::submit-clicked
  interceptors
  (fn [{:keys [db]} _]
    {:db       (assoc-in db [::document ::show-errors?] true)
     :dispatch [::try-submit]}))


(rf/reg-event-db
  ::close-clicked
  interceptors
  (fn [db _]
    (-> db reset-db-wo-user)))


(defn handle-open [group-id user]
  #(>evt [::open
          group-id
          (set/rename-keys user {:email      :user/email
                                 :first-name :user/first-name
                                 :id         :db/id
                                 :last-name  :user/last-name})
          [:app.front.view.group.admin.user-management/remove-user (:db/id user)]]))


(defn modal [tr]
  [cc/modal
   {:open                  (or (<sub [::modal-open?]) false)
    :primary-button-text   (tr [:user-management/remove])
    :secondary-button-text (tr [:user-management/cancel])
    :modal-heading         (tr [:user-management/remove-account])
    :on-request-close      #(>evt [::close-clicked])
    :on-request-submit     #(>evt [::submit-clicked])
    :on-secondary-submit   #(>evt [::close-clicked])
    :danger                true}
   [:div.flex.flex-col
    [:p.bx--modal-content__text.mb-6
     (tr [:user-management/remove-from-group-confirmation])]
    [:p.bx--modal-content__text.bx--type-body-short-01
     (let [full-name (str (<sub [::document [:user/first-name]]) " " (<sub [::document [:user/last-name]]))
           username  (or (<sub [::document [:user/email]]) (<sub [::document [:user/username]]))]
       (if (str/blank? full-name)
         username
         (str full-name " (" username ")")))]]])


(defn remove-button [{:keys [tr group-id user remove-disabled? tr-key]}]
  (cc/button
    {:kind             :tertiary
     :size             :small
     :disabled         (boolean remove-disabled?)
     :icon             i/trash
     :icon-description (tr [(or tr-key :user-management/remove)])
     :on-click         (handle-open group-id user)}
    (tr [(or tr-key :user-management/remove)])))
